'use client';
import React from 'react';

import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, Security, DetailedQuote } from '@benzinga/quotes-manager';
import { SafeType } from '@benzinga/safe-await';

export const useDetailedQuote = (symbol: Security): SafeType<DetailedQuote> | undefined => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesManager);
  const [details, setDetails] = React.useState<SafeType<DetailedQuote> | undefined>(() => {
    const quote = quotesManager.getDetailedQuotesCached([symbol])[symbol];
    if (quote) {
      return { ok: quote };
    } else {
      return undefined;
    }
  });

  React.useEffect(() => {
    const getQuote = async () => {
      const details = await quotesManager.getDetailedQuotes([symbol]);
      if (details.ok) {
        setDetails({ ok: details.ok[symbol] });
      } else {
        setDetails({ err: details.err });
      }
    };
    getQuote();
  }, [quotesManager, symbol]);

  return details;
};
